import { useCallback, useEffect, useRef, useState } from "react";
import { debounce } from "lodash";

import locationService from "../../service/locationService";
 
export default function useAutocompleteAddress(input) {
  const [predictions, setPredictions] = useState([]);
  const [loadingState, setLoadingState] = useState(false);
  const debounceSeconds = 1;

  // Always holds the field's latest value, so a response that resolves after
  // the field has since changed (e.g. been cleared) can be told apart from a
  // still-current one and ignored instead of repopulating stale predictions.
  const latestInputRef = useRef(input);
  latestInputRef.current = input;

  function getPlacePredictions(currentInput) {
    setLoadingState(true);
    locationService.autocompleteAddress({ input: currentInput })
      .then(results => {
        if (latestInputRef.current !== currentInput) return;
        setPredictions(results || []);
      })
      .finally(() => {
        if (latestInputRef.current !== currentInput) return;
        setLoadingState(false);
      });
  };

  const debouncedGetPlacePredictions = useCallback(
      debounce(getPlacePredictions, debounceSeconds * 1000),
      []
  );

  useEffect(() => {
    if (input && !(input.trim() === '')) {
      debouncedGetPlacePredictions(input)
    } else {
      debouncedGetPlacePredictions.cancel();
      setPredictions([]);
      setLoadingState(false);
    }
  }, [input]);

  return {
    predictions,
    loadingState
  };
}
